export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15102.5572b893.jpg";